import { render, staticRenderFns } from "./Corrieri.vue?vue&type=template&id=a6b1787c"
import script from "./Corrieri.vue?vue&type=script&lang=js"
export * from "./Corrieri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports